cv.Paragraph = Backbone.Model.extend({
  defaults : {
    text : '',
    markups : [],
    meta : [],
    layout: {
      tag : 'p',
      align : 'left',
      width : 'auto'
    }
  },

  initialize: function(){
    console.log('Paragraph model loaded.');
  }
});

cv.Paragraphs = Backbone.Collection.extend({
  model: cv.Paragraph,

  initialize: function(){
    console.log('Paragraphs collection loaded.');
  }
});
